import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteContentFolderDocument } from './delete.generated';

export const useDeleteContentFolder = (
  options: ApiOptions<typeof DeleteContentFolderDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteContentFolderDocument, {
    ...useNotifications(DeleteContentFolderDocument, {
      failure: t('api.content_folders.delete_error'),
      success: t('api.content_folders.delete_success'),
    }),
    ...options,
  });
};
